import CaseName from "shared/Types/cases";

import { ArtprogresData } from "./Artprogres/ArtprogresData";
import { BeefuryData } from "./Beefury/BeefuryData";
import { BeksinskiData } from "./Beksinski/BeksinskiData";
import { FarmaBialka } from "./FarmaBialka/FarmaBialkaData";
import { FizosteoData } from "./Fizosteo/FizosteoData";
import { FundacjaData } from "./Fundacja/FundacjaData";
import { HeatingData } from "./Heating/HeatingData";
import { JanczakiData } from "./Janczaki/JanczakiData";
import { KlimalabData } from "./Klimalab/KlimalabData";
import { MatthiasData } from "./Matthias/MatthiasData";
import { MercedesData } from "./Mercedes/MercedesData";
import { NykartData } from "./Nykart/NykartData";
import { OhTimeData } from "./OhTime/OhTimeData";
import { PizzaData } from "./Pizza/PizzaData";
import { PrototypPerfumData } from "./PrototypPerfum/PrototypPerfumData";
import { SocialmonsterData } from "./Socialmonster/SocialmonsterData";
import { SocialmonsterNewData } from "./SocialmonsterNew/SocialmonsterNewData";
import { StreetwearData } from "./Streetwear/StreetwearData";
import { PogorzanskiTygielSmakowData } from './PogorzanskiTygielSmakow/PogorzanskiTygielSmakowData';
import { BloodlabData } from './Bloodlab/BloodlabData';
import { RowerowaData } from "./RowerowaPrzygoda/RowerowaData";
import { PpwbData } from "./Ppwb/PpwbData";
import { BestShoesData } from "./BestShoes/BestShoesData";
import { BruczekData } from "./Bruczek/BruczekData";
import { GrupaSoloData } from "./GrupaSolo/GrupaSoloData";
import { BispolWwwData } from "./BispolWww/BispolWwwData";
import { ExFitData } from "./ExitFit/ExFitData";

export const useCaseData = (name) => {
  const data = {
    // [CaseName.EXFIT]: ExFitData(),
    // [CaseName.BISPOLWWW]: BispolWwwData(),
    // [CaseName.GRUPASOLO]: GrupaSoloData(),
    // [CaseName.BRUCZEK]: BruczekData(),
    // [CaseName.BESTSHOES]: BestShoesData(),
    [CaseName.PPWB]: PpwbData(),
    [CaseName.ROWEROWAPRZYGODA]: RowerowaData(),
    [CaseName.Bloodlab]: BloodlabData(),
    [CaseName.PogorzanskiTygielSmakow]: PogorzanskiTygielSmakowData(),
    [CaseName.FARMA]: FarmaBialka(),
    [CaseName.FUNDACJA]: FundacjaData(),
    [CaseName.MERCEDES]: MercedesData(),
    [CaseName.PIZZA]: PizzaData(),
    [CaseName.BEKSINSKI]: BeksinskiData(),
    [CaseName.FIZOSTEO]: FizosteoData(),
    [CaseName.STREETWEAR]: StreetwearData(),
    [CaseName.MATTHIAS]: MatthiasData(),
    [CaseName.NYKART]: NykartData(),
    [CaseName.JANCZAKI]: JanczakiData(),
    [CaseName.SOCIALMONSTER]: SocialmonsterData(),
    [CaseName.SOCIALMONSTERNEW]: SocialmonsterNewData(),
    [CaseName.ARTPROGRES]: ArtprogresData(),
    [CaseName.BEEFURY]: BeefuryData(),
    [CaseName.HEATING]: HeatingData(),
    [CaseName.KLIMALAB]: KlimalabData(),
    [CaseName.OHTIME]: OhTimeData(),
    [CaseName.PERFUMS]: PrototypPerfumData(),
  };

  if (!name) {
    return data;
  }
  return data[name];
};
